export class ViolationsDetectionNotificationArguments {
    'resourceIds';
    'totalResources';
    'detected';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "detected",
            "baseName": "detected",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ViolationsDetectionNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
